import { CALL_API } from 'middleware/api';
import { includeCreditReportParam } from 'utils/creditReportAccounts';
import { apiEvents, GET_SPACES_SUCCESS, GET_SPACE_INFO_SUCCESS, SELECTED_SPACE, GET_SPACE_INFO_REQUEST, GET_SPACE_INFO_FAILURE, SWITCHED_SPACE, FETCH_SPACES, EDIT_SPACE_INFO, GET_SPACE_INVITE_DETAILS_SUCCESS, GET_SPACE_INVITE_DETAILS_REQUEST, GET_SPACE_INVITE_DETAILS_FAILURE, ACCEPT_SPACE_INVITE_SUCCESS, ACCEPT_SPACE_INVITE_REQUEST, ACCEPT_SPACE_INVITE_FAILURE, GET_INVITES_FOR_SPACE_SUCCESS, GET_INVITES_FOR_SPACE_REQUEST, GET_INVITES_FOR_SPACE_FAILURE, SET_SHOW_SPACE_LOCK, DELETE_SPACE_SUCCESS, DELETE_SPACE_REQUEST, DELETE_SPACE_FAILURE, } from '../constants';
export function getMySpacesSuccess(spaces) {
    return {
        type: GET_SPACES_SUCCESS,
        payload: { spaces },
    };
}
export function getMySpaces() {
    return {
        [CALL_API]: {
            endpoint: `/spaces${includeCreditReportParam('?')}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: [
                apiEvents.getSpaces[0],
                apiEvents.getSpaces[1],
                apiEvents.getSpaces[2],
            ],
        },
    };
}
export function createNewSpace(name, type) {
    return {
        [CALL_API]: {
            endpoint: `/spaces`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name,
                type,
            }),
            types: apiEvents.createSpace,
        },
    };
}
export function setSpaceName(spaceId, name) {
    return {
        [CALL_API]: {
            endpoint: `/spaces/${spaceId}`,
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name }),
            types: apiEvents.setSpaceName,
        },
    };
}
export function getSpaceInfoSuccess(spaceInfo) {
    return {
        type: GET_SPACE_INFO_SUCCESS,
        payload: spaceInfo,
    };
}
export function getSpaceInfo(id) {
    return {
        [CALL_API]: {
            endpoint: `/spaces/${id}${includeCreditReportParam('?')}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            extra: id,
            types: [
                GET_SPACE_INFO_REQUEST,
                GET_SPACE_INFO_SUCCESS,
                GET_SPACE_INFO_FAILURE,
            ],
        },
    };
}
export function getSpaceInviteDetailsSuccess(spaceInvite, inviteId) {
    return {
        type: GET_SPACE_INVITE_DETAILS_SUCCESS,
        payload: spaceInvite,
        extra: { inviteId },
    };
}
export function getSpaceInviteDetails(spaceId, inviteId) {
    return {
        [CALL_API]: {
            endpoint: `/spaces/${spaceId}/invite/${inviteId}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            extra: { inviteId },
            types: [
                GET_SPACE_INVITE_DETAILS_REQUEST,
                GET_SPACE_INVITE_DETAILS_SUCCESS,
                GET_SPACE_INVITE_DETAILS_FAILURE,
            ],
        },
    };
}
export function editSpaceInfoSuccess(spaceId) {
    return {
        type: EDIT_SPACE_INFO,
        payload: { spaceId },
    };
}
export function deleteSpaceSuccess(defaultSpaceId) {
    return {
        type: DELETE_SPACE_SUCCESS,
        payload: { defaultSpaceId },
    };
}
export function deleteSpace(id) {
    return {
        [CALL_API]: {
            endpoint: `/spaces/${id}`,
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: [DELETE_SPACE_REQUEST, DELETE_SPACE_SUCCESS, DELETE_SPACE_FAILURE],
        },
    };
}
export function setAccountSpace(accountId, spaceId) {
    return {
        [CALL_API]: {
            endpoint: `/accounts/${accountId}/space/${spaceId}`,
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: apiEvents.setAccountSpace,
        },
    };
}
export function joinSpace(accessCode) {
    return {
        [CALL_API]: {
            endpoint: `/spaces/join/${accessCode}`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: apiEvents.joinSpace,
        },
    };
}
export function deleteSpaceMember(id, userId) {
    return {
        [CALL_API]: {
            endpoint: `/spaces/${id}/members/${userId}`,
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: apiEvents.deleteSpaceMember,
        },
    };
}
export function deleteSpaceMemberSuccess(spaceId, userId) {
    return {
        type: apiEvents.deleteSpaceMember[1],
        payload: { spaceId, userId },
    };
}
export function rejectSpaceInvite(spaceId, inviteId) {
    return {
        [CALL_API]: {
            endpoint: `/spaces/${spaceId}/invites/${inviteId}/reject`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: apiEvents.rejectSpaceInvite,
        },
    };
}
export function acceptSpaceInvite(spaceId, inviteId) {
    return {
        [CALL_API]: {
            endpoint: `/spaces/${spaceId}/invites/${inviteId}/accept`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: [
                ACCEPT_SPACE_INVITE_REQUEST,
                ACCEPT_SPACE_INVITE_SUCCESS,
                ACCEPT_SPACE_INVITE_FAILURE,
            ],
        },
    };
}
export function setSelectedSpace(id) {
    return {
        type: SELECTED_SPACE,
        payload: id,
    };
}
export function saveLastUsedSpace(spaceId) {
    return {
        [CALL_API]: {
            endpoint: '/me/remember-space',
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                spaceId,
            }),
            types: [
                'SAVE_LAST_USED_FAILURE',
                'SAVE_LAST_USED_SUCCESS',
                'SAVE_LAST_USED_REQUEST',
            ],
            extra: {
                spaceId,
            },
        },
    };
}
export function switchedSpace() {
    return {
        type: SWITCHED_SPACE,
    };
}
export const fetchSpacesAction = () => ({
    type: FETCH_SPACES,
});
export const invitePeopleToSpace = (spaceId, handles) => ({
    [CALL_API]: {
        endpoint: `/spaces/${spaceId}/invites`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ handles }),
        types: [
            'INVITE_PEOPLE_TO_SPACE_REQUEST',
            'INVITE_PEOPLE_TO_SPACE_SUCCESS',
            'INVITE_PEOPLE_TO_SPACE_FAILURE',
        ],
    },
});
export const sendSpaceInviteReminder = (spaceId, spaceUserId, inviteId) => ({
    [CALL_API]: {
        endpoint: `/spaces/${spaceId}/reminders`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            type: 'SPACE_INVITE_REMINDER',
            spaceUserId,
            inviteId,
        }),
        types: [
            'SEND_SPACE_INVITE_REMINDER_REQUEST',
            'SEND_SPACE_INVITE_REMINDER_SUCCESS',
            'SEND_SPACE_INVITE_REMINDER_FAILURE',
        ],
    },
});
export const sendSpaceReminder = (spaceId, type) => ({
    [CALL_API]: {
        endpoint: `/spaces/${spaceId}/reminders`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ type }),
        types: [
            'SEND_SPACE_REMINDER_REQUEST',
            'SEND_SPACE_REMINDER_SUCCESS',
            'SEND_SPACE_REMINDER_FAILURE',
        ],
    },
});
export const cancelSpaceInvite = (spaceId, inviteId) => ({
    [CALL_API]: {
        endpoint: `/spaces/${spaceId}/invites/${inviteId}/cancel`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'CANCEL_SPACE_INVITE_REQUEST',
            'CANCEL_SPACE_INVITE_SUCCESS',
            'CANCEL_SPACE_INVITE_FAILURE',
        ],
    },
});
export const getInvitesForSpace = (spaceId) => ({
    [CALL_API]: {
        endpoint: `/spaces/${spaceId}/invites`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            GET_INVITES_FOR_SPACE_REQUEST,
            GET_INVITES_FOR_SPACE_SUCCESS,
            GET_INVITES_FOR_SPACE_FAILURE,
        ],
        extra: { spaceId },
    },
});
export const setShowSpaceLock = (value) => ({
    type: SET_SHOW_SPACE_LOCK,
    payload: value,
});
